import React, { createContext } from 'react';
export var HeadingContext = createContext(2);
export default function SemanticSection(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(HeadingContext.Consumer, null, function (level) {
    return /*#__PURE__*/React.createElement(HeadingContext.Provider, {
      value: level + 1
    }, children);
  });
}